import React, { useEffect, useState } from 'react';

import { Skeleton } from '@material-ui/lab';
import { uniqBy } from 'lodash';
import { getRolesForOrgFunction } from 'screens/admin/Competencies/model/OrganizationFunctions';
import styled from 'styled-components';
import { GutterCSS } from 'styles/common';

import theme from 'constants/theme';

import { getOrganizationFunctions } from 'services/admin';

import { useCohortCreationContext } from './CohortSidePanelContext';
import { StyledDropdownListElement } from './CommonComponents';

const flattenArray = (deepArray) => [...new Set(deepArray.flat().filter((item) => !!item))];

const CohortCreationRoles = ({ sectionId }) => {
  const {
    state: { selectedOptions },
    appendSelectedValue,
    deleteSelectedValue,
  } = useCohortCreationContext();

  // functions and levels
  const [roles, setRoles] = useState(null);
  const [loadingRoles, setLoadingRoles] = useState(true);
  const fetchData = () => {
    setLoadingRoles(true);
    getOrganizationFunctions()
      .then((res) => {
        let rolesArrayOfArray = res.map((func) => getRolesForOrgFunction(func));
        rolesArrayOfArray = flattenArray(rolesArrayOfArray);
        rolesArrayOfArray = uniqBy(rolesArrayOfArray, 'uuid');
        setRoles(rolesArrayOfArray);
      })
      .catch((err) => {
        console.error('Error in fetching functions : ', err);
      })
      .finally(() => {
        setLoadingRoles(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  // end of functions and levels

  if (loadingRoles) {
    return <Skeleton />;
  }

  return (
    <DropdownContainer>
      {roles?.map(({ name, uuid }) => {
        const checked = selectedOptions[sectionId] ? selectedOptions[sectionId][uuid] : false;
        return (
          <OptionWrapper
            onClick={() => {
              const cObj = { id: uuid, displayName: name };
              if (selectedOptions[sectionId] && selectedOptions[sectionId][uuid]) deleteSelectedValue(sectionId, cObj);
              else appendSelectedValue(sectionId, cObj);
            }}
          >
            <StyledDropdownListElement
              checked={checked}
              label={name}
              radioColor={theme.palette.icons.blue}
              hoverColor={theme.palette.icons.blue}
            />
          </OptionWrapper>
        );
      })}
    </DropdownContainer>
  );
};

const OptionWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

const DropdownContainer = styled.div`
  padding: 0.5rem 1.5rem;
  width: 100%;
  ${GutterCSS};
`;

export default CohortCreationRoles;
